import { createStore } from 'redux';


const reducer = (state, action) => {
  if (action.type === "CARRITO") {
    //console.log("CARRITO del store")
    return {
      interface: "carrito",
      vieneDelCarrito: true,
      carritoVacio: false,
    };
  } else if (action.type === "LISTADO") {
    //console.log("entro en LISTADO del store, carrito vacio", action.carritoVacio)
    return {
      interface: "listado",
      catSeleccionadaMenuPrincipal: action.catSeleccionadaMenuPrincipal,
      diseno: action.diseno,
      carritoVacio: action.carritoVacio
    }
  } else if (action.type === "SIGUE_COMPRANDO") {
      //console.log("entro en SIGUE_COMPRANDO del store")
      return {
        carritoVacio: false,
        interface: "listado",
        vieneDelCarrito: true

    };
  } else if (action.type === "COMPRA_COMPLETADA") {
      //console.log("confirmo la compra")
      return {
        carritoVacio: true,
        interface: "estadoPedido",
        vieneDelCarrito: true,
        hayPedidoPendiente: true

    };
  } else if (action.type === "CARRITO_VACIO") {
        //console.log("carrito vacio del store")
        return {
          carritoVacio: true,
          interface: "listado",
          vieneDelCarrito: true

      }
    }
    else if (action.type === "CARRITO_ESTADO") {
            //console.log("carrito vacio")
          return {
            carritoVacio: action.carritoVacio,
            interface: "menuPrincipal",
            vieneDelCarrito: false
          };
  }    else if (action.type === "MENU_PRINCIPAL") {
              //console.log("carrito vacio")
            return {
              interface: "menuPrincipal",
              carritoVacio: action.carritoVacio
            };
    } else if (action.type === "ESTADO_PEDIDO") {
                //console.log("Estado Pedido", action.nroPedidoMasReciente)
              return {
                interface: "estadoPedido",
                nroPedidoMasReciente: action.nroPedidoMasReciente
              };
      }

  return state;
};


//export default createStore(reducer, { interface: "listado", carritoVacio: true, catSeleccionadaMenuPrincipal: false, diseno: "pizza" });
export default createStore(reducer, { carritoVacio: true, catSeleccionadaMenuPrincipal: false, diseno: "pizza" });
